import { render, staticRenderFns } from "./DiscountCouponStore.vue?vue&type=template&id=62580bf0&"
import script from "./DiscountCouponStore.vue?vue&type=script&lang=js&"
export * from "./DiscountCouponStore.vue?vue&type=script&lang=js&"
import style0 from "./DiscountCouponStore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports